<div class="example-sidenav-content">
    

    <div class="container">
        <div class="dashboard-header">
            <button type="button" (click)="goBack()" mat-button>
                <mat-icon>chevron_left</mat-icon>
            </button>
            <h2 class="webapp-title-secondary">Gestor de paquetes</h2>
        </div>

        <div class="toolbar">
            <div class="flex-row">
                <app-smart-select [tableName]="'clientDetails'" (selectedObj)="onSelection($event)" class="center"></app-smart-select>
                <h4>{{clientId}}</h4>
            </div>
            <div class="buttons">
            <button class="btn secondary" (click)="switchHow()"><i class="fa-solid fa-circle-info"></i>¿How to?</button>
            <button class="btn primary" (click)="switchProductList()">Product List</button>
            </div>
        </div>

        <div class="content">

            <!-- LISTA DE PAQUETES YA EXISTENTES -->
            <div class="card">
                <div class="card-header">
                    <h3>PAQUETES EXISTENTES</h3>
                    <button class="refresh-btn" (click)="reloadPacks()"><mat-icon>sync</mat-icon></button>
                    <i class="fa-solid fa-chevron-down" (click)="showPacks = !showPacks" style="cursor: pointer;"></i>
                </div>
                <div>
                    <span class="flex" style="justify-content: space-between;">
                        <p class="mb-0 text-muted">Total: {{loadedPackages.length}}</p>
                    </span>
                    <mat-spinner *ngIf="isPacksLoading()"></mat-spinner>
                    <ul class="top-selling-products pb-0 mb-0 px-0" style="max-height: 160px; overflow-y: scroll;" *ngIf="showPacks">
                        <li class="product-item" *ngFor="let pack of loadedPackages" (click)="openModal(pack)" style="padding: 0.5rem;">
                            
                            <div class="product-info">
                                <div class="product-img">
                                    <img class="rounded-circle" src="../assets/img/users/4.jpg" alt="avatar">
                                </div>
                                <div class="product-details">
                                    <h5>{{pack.name}}</h5>
                                    <p>Type:{{pack.package_type}}</p>
                                    <p>ID:{{pack.package_id}}</p>
                                </div>
                                
                            </div>
                            <div class="product-amount">
                                <div class="price">${{pack.price}}</div>
                                <div class="items-sold">{{pack.category}}</div>
                            </div>
                        </li>
                    </ul>
                    
                </div>
            </div>

            <!-- CREAR UN PAQUETE NUEVO -->
            <div class="card">
                <div class="card-header">
                    <h3>CREAR UN PAQUETE NUEVO</h3>
                    <button class="add-btn" mat-fab color="primary" (click)="newPackage()">+</button>
                </div>
                <div class="">
                    <p *ngIf="packages.length ==0">Crear paquetes de servicios o productos.</p>
                    <div class="flex-column">
                    
                        <mat-accordion *ngIf="packages.length >0">
                            <mat-expansion-panel id="noBordersPanel" *ngFor="let pack of packages;let i = index;" [expanded]="panelOpenState[i]" (opened)="panelOpenState[i] = true" (closed)="panelOpenState[i] = false">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>Paquete {{i+1}}</mat-panel-title>
                                    <mat-panel-description>
                                        {{pack.price}} {{pack.currency}} /  {{pack.package_type}}
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
            
                                <div class="flex-column" style="margin-top: 1rem;">
                                    <mat-label>Load template</mat-label>
                                    <mat-button-toggle-group style="width: fit-content;">
                                        <mat-button-toggle mat-button [matMenuTriggerFor]="menu" value="other">Other</mat-button-toggle>
                                        <mat-button-toggle value="basic" (click)="onTemplateSelect('basic',pack)">Basic</mat-button-toggle>
                                        <mat-button-toggle value="premium" (click)="onTemplateSelect('premium',pack)">Premium</mat-button-toggle>
                                        <mat-button-toggle value="full" (click)="onTemplateSelect('full',pack)">Full</mat-button-toggle>
                                    </mat-button-toggle-group>
                                </div>

                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="onTemplateSelect('general',pack)">General</button>
                                    <button mat-menu-item (click)="onTemplateSelect('legal',pack)">Legal</button>
                                    <button mat-menu-item (click)="onTemplateSelect('tourism',pack)">Tourism</button>
                                </mat-menu>
            
                                <div class="flex-column" style="margin-top: 1rem;">
            
                                    <mat-label>Package info</mat-label>
                                    <div>
                                        <mat-form-field appearance="outline" style="max-width: 120px;margin-right: 1rem;">
                                            <mat-label>Type</mat-label>
                                            <mat-select (selectionChange)="onSelectType($event,pack)">
                                                <mat-option *ngFor="let type of packageTypes" [value]="type">
                                                    {{type.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
            
                                        <mat-form-field style="max-width: 60px;margin-right: 1rem;" appearance="outline">
                                            <mat-label>Price</mat-label>
                                            <input matInput placeholder="" [(ngModel)]="pack.price" name="price">
                                        </mat-form-field>
            
                                        <mat-form-field style="max-width: 150px;margin-right: 1rem;" appearance="outline">
                                            <mat-label>Description</mat-label>
                                            <input matInput placeholder="" [(ngModel)]="pack.description" name="description">
                                        </mat-form-field>
                                    </div>
            
                                    <!--                 <mat-form-field style="max-width: 100px;margin-right: 1rem;" appearance="outline">
                                    <mat-label>Name</mat-label>
                                    <input matInput placeholder="" [(ngModel)]="pack.name">
                                    </mat-form-field> -->
            
                    <!--            <mat-form-field style="max-width: 80px;margin-right: 1rem;" appearance="outline">
                                        <mat-label>Id</mat-label>
                                        <input matInput placeholder="" [(ngModel)]="pack.package_id">
                                    </mat-form-field> -->
            
                            <!--     <div>
                                        <button mat-icon-button>
                                            <mat-icon (click)="openSelect()"><i class="fas fa-dollar-sign"></i></mat-icon>
                                        </button>
                                        <mat-select id="currency" #mySelect (selectionChange)="onSelectCurrency($event,pack)">
                                            <mat-option *ngFor="let curr of currencies" [value]="curr">
                                                {{curr}}
                                            </mat-option>
                                        </mat-select>
                                    </div> -->
            
                            <!--    <mat-form-field appearance="outline" style="max-width:150px;margin-right: 1rem;">
                                        <mat-label>Category</mat-label>
                                        <mat-select (selectionChange)="onSelectCategory($event,pack)">
                                            <mat-option *ngFor="let cat of categories" [value]="cat">
                                                {{cat}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field> -->
            
                                    <mat-form-field appearance="outline" style="width: 100%;" *ngIf="products.length>0">
                                        <mat-label>Servicio/Producto</mat-label>
                                        <mat-select (selectionChange)="onSelectProduct($event,pack)">
                                            <mat-option *ngFor="let food of products" [value]="food">
                                                {{food.product}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
            
                                    <div>
                                        <span>Servicios incluidos:</span>
                                        <div class="card-bordered" style="text-align: justify;">
                                            <mat-list *ngIf="pack.products && pack.products.length>0">
                                                <span *ngFor="let p of pack.products">
                                                    <mat-list-item class="flex small-text"><i class="far fa-minus-square icon icon-gray" (click)="removeProduct(p,pack)"></i>{{p.product}}</mat-list-item>
                                                    <mat-divider></mat-divider>
                                                </span>
                                            </mat-list>
                                            <mat-list *ngIf="pack.products && pack.products.length<=0">
                                                <span>
                                                    <mat-list-item class="flex small-text">Error: No products were loaded to this pack</mat-list-item>
                                                    <mat-divider></mat-divider>
                                                </span>
                                            </mat-list>
                                        </div>
                                    </div>
                                </div>
                                <button mat-raised-button color="primary"  style="margin: auto;" class="margin-top-1rem" [disabled]="!areFieldsFilled(i)" (click)="savePackage(pack,i)">Save pack</button>
            
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                    
                    <!-- CREATE BUTTON -->
                    <div style="margin-top: 1rem;">
                        
                    </div>
                </div>                   
            </div>

            <!-- LISTA DE PRODUCTOS Y SERVICIOS -->
            <div class="card" *ngIf="showProductsList">
                <div class="card-header">
                    <h3>LISTA DE PRODUCTOS Y SERVICIOS</h3>
                </div>
                   
                <div class="card-body">
                    <p>Productos ofrecidos, que conforman paquetes o servicios puntuales.</p>
                    <ul class="top-selling-products" style="max-height: 260px; overflow-y: scroll;">
                        <li class="product-item" *ngFor="let product of products">
                            <div class="product-img">
                                <img class="rounded-circle" src="../assets/img/users/4.jpg" alt="avatar">
                            </div>
                            <div class="product-info">
                                <div class="product-name">
                                    <app-smart-text [limit]="45" [text]="product.product"></app-smart-text>
                                </div>
                                <div class="price">{{product.description}}</div>
                            </div>
                            <div class="product-amount">
                                <div class="product-price">${{product.price}}</div>
                                <div class="items-sold">{{product.category}}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- ¿COMO CREAR UN PLAN? -->
            <div class="card" *ngIf="showHowTo">
                <div class="card-header">
                    <h3>¿Cómo crear un plan?</h3>
                </div>
                <div class="card-body">
                    <p>Pasos a seguir para la creación de un plan</p>
                    <span class="flex" style="justify-content: space-between;">
                        <label class="main-content-label mb-3 pt-1"></label>
                    </span>
                    <ul>
                        <li><p>1. Elegir cliente</p></li>
                        <li><p>2. Crear un plan</p></li>
                        <li><p>3. Asociar paquetes a un plan</p></li>
                    </ul>
                </div>
                
            </div>
            
            <!-- PLANES ASOCIADOS A ESTE CLIENTE -->
            <div class="card">
                <div class="card-header">
                    <h3>PLANES ASOCIADOS A ESTE CLIENTE</h3>
                    <button class="refresh-btn" (click)="reloadPlans()"><mat-icon>sync</mat-icon></button>
                </div>
                
                <div class="card-body" style="overflow-y: scroll; max-height: 400px;">
                    <p *ngIf="plans && plans.length<=0">No plans associated to this client yet</p>
                    <mat-accordion *ngIf="plans && plans.length>0">
                        <mat-expansion-panel hideToggle *ngFor="let plan of plans">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                                {{plan.name}}
                            </mat-panel-title>
                            <mat-panel-description>
                                {{plan.description}}
                            </mat-panel-description>
                          </mat-expansion-panel-header>
                          
                          <!-- CONTENT -->
                          <div class="p-3 font-weight-normal mb-0"><span class="price">{{plan.price}} {{plan.currency}}</span></div>
                            <ul class="list-unstyled mb-0">
                                <li><i class="fe fe-check me-2 text-success"></i>{{plan.category}}</li>
                                <li><i class="fe fe-check me-2 text-success"></i>{{plan.package_type}}</li>
                                <li><i class="fe fe-check me-2 text-success"></i>{{plan.category}}</li>
                            </ul>

                        </mat-expansion-panel>
                    </mat-accordion>

                    <!-- <div class="product-timeline card-body pt-3 mt-1">
                       <div >
                        <h4></h4>
                        <p>{{plan.description}}</p>

                        <ul class="timeline-1 mb-0" >
                            <li class="mt-0"> <i class="mdi mdi-cart-outline product-icon"></i> <span class="font-weight-semibold mb-4 tx-14 ">{{plan.price}} {{plan.currency}}</span> <a href="javascript: void(0)" class="float-end tx-11 text-muted">-</a>
                                <p class="mb-0 text-muted tx-12">Precio</p>
                            </li>
                            <li class="mt-0"> <i class="ti-bar-chart-alt product-icon"></i> <span class="font-weight-semibold mb-4 tx-14 ">{{plan.package_type}}</span> <a href="javascript: void(0)" class="float-end tx-11 text-muted">-</a>
                                <p class="mb-0 text-muted tx-12">Tipo</p>
                            </li>
                            <li></li>
                            <li class="mt-0 mb-0"><i class="si si-eye product-icon"></i> <span class="font-weight-semibold mb-4 tx-14 ">{{plan.category}}</span> <a href="javascript: void(0)" class="float-end tx-11 text-muted">-</a>
                            <p class="mb-0 text-muted tx-12">Categoría</p>
                            </li>
                           
                        </ul>
                       </div>
                        
                    </div> -->
                </div>
            </div>

            <!-- CREAR PLAN Y ASOCIAR PAQUETES A PLANES -->
            <div class="card">
                <div class="card-header">
                    <h3>CREAR PLAN/ASOCIAR PACKS</h3>
                </div>

                <div class="card-body">
                    <p>Crear los planes que se conforman de 1 o más paquetes. Los paquetes tienen a su vez una serie de productos/servicios y un precio total.</p>
                </div>
                
                <h5>Create plan</h5>
                <app-dynamic-crud [crudConfig]="config1" ></app-dynamic-crud>

                <h5>Associate packages</h5>
                <!-- <app-dynamic-crud [crudConfig]="config2"></app-dynamic-crud>  -->
            </div>
        </div>
    </div>
</div>